import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import components from "./components/components";

const principle: Slide = {
  description:
    "The absorption coefficient for one of the 11 proposed materials is plotted as a function of the frequency. The material parameters are shown for the selected material in the table.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Matelys reference material" },
            { name: "Fibrous material 1" },
            { name: "Fibrous material 2" },
            { name: "Fibrous material 3" },
            { name: "Fibrous material 4" },
            { name: "Foam 1" },
            { name: "Foam 2" },
            { name: "Foam 3" },
            { name: "Atypical foam 1" },
            { name: "Atypical foam 2" },
            { name: "Atypical foam 3" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], [], [], [], [], [], [], []],
      components: components,
    },
  },
};

export default principle;
